// extracted by css-extract-rspack-plugin
export default {"UpsellCardComponent":"sAkcM","Large":"ZMViY","MainStack":"iQxiq","Default":"wcbw7","Title":"SpCXb"};